var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (Array, _s, article, artwork, artworkSize, contain, disableEnd, disableStart, displayPrice, displayPurchase, embed, encodeURIComponent, hasAuctionPartner, hasInstitutionPartner, hideShare, image, imageHeight, imageSizes, imageWidth, index, isAuction, items, length, resize, sd, set, showBlurbs, showBuyButton, showBuyLink, showContact, slideshowArtworks, undefined) {
jade_mixins["share"] = jade_interp = function(description, media, url){
var block = (this && this.block), attributes = (this && this.attributes) || {};
url = url || encodeURIComponent(sd.APP_URL + sd.CURRENT_PATH)
description = description || ''
media = media || ''
buf.push("<a data-message=\"Share via email\" data-service=\"email\"" + (jade.attr("href", "mailto:?subject=" + (description) + "&body=Check out " + (description) + " on Artsy: " + (url) + "", true, true)) + " class=\"share-by-email black-tooltip\"><i class=\"icon-mail\"></i></a><a data-message=\"Post to Facebook\" data-service=\"facebook\"" + (jade.attr("href", "https://www.facebook.com/sharer/sharer.php?u=" + (url) + "", true, true)) + " target=\"_blank\" class=\"share-to-facebook black-tooltip\"><i class=\"icon-facebook\"></i></a><a data-message=\"Share on Twitter\" data-service=\"twitter\"" + (jade.attr("href", "https://twitter.com/intent/tweet?original_referer=" + (url) + "&text=" + (description) + "&url=" + (url) + "&via=artsy", true, true)) + " target=\"_blank\" class=\"share-to-twitter black-tooltip\"><i class=\"icon-twitter\"></i></a>");
};

































jade_mixins["share"] = jade_interp = function(description, media, url){
var block = (this && this.block), attributes = (this && this.attributes) || {};
url = url || encodeURIComponent(sd.APP_URL + sd.CURRENT_PATH)
description = description || ''
media = media || ''
buf.push("<div class=\"share-item\"><a data-message=\"Post to Facebook\" data-service=\"facebook\"" + (jade.attr("href", "https://www.facebook.com/sharer/sharer.php?u=" + (url) + "", true, true)) + " target=\"_blank\" class=\"share-to-facebook\"><i class=\"icon-facebook-f icon-in-table\"><span class=\"screen-reader-text\">Post to Facebook</span></i></a></div><div class=\"share-item\"><a data-message=\"Share on Twitter\" data-service=\"twitter\"" + (jade.attr("href", "https://twitter.com/intent/tweet?original_referer=" + (url) + "&text=" + (description) + "&url=" + (url) + "&via=artsy", true, true)) + " target=\"_blank\" class=\"share-to-twitter\"><i class=\"icon-twitter icon-in-table\"><span class=\"screen-reader-text\">Share on Twitter</span></i></a></div><div class=\"share-item\"><a data-message=\"Share via email\" data-service=\"email\"" + (jade.attr("href", "mailto:?subject=" + (description) + "&body=Check out " + (description) + " on Artsy: " + (url) + "", true, true)) + " class=\"share-by-email\"><i class=\"icon-mail icon-in-table\"><span class=\"screen-reader-text\">Share via email</span></i></a></div>");
};
jade_mixins["share-fixed"] = jade_interp = function(description, media, url){
var block = (this && this.block), attributes = (this && this.attributes) || {};
url = url || encodeURIComponent(sd.APP_URL + sd.CURRENT_PATH)
description = description || ''
media = media || ''
buf.push("<a data-message=\"Post to Facebook\" data-service=\"facebook\"" + (jade.attr("href", "https://www.facebook.com/sharer/sharer.php?u=" + (url) + "", true, true)) + " target=\"_blank\" class=\"share-to-facebook\"><i class=\"icon-facebook-f\"><span class=\"screen-reader-text\">Post to Facebook</span></i></a><a data-message=\"Share on Twitter\" data-service=\"twitter\"" + (jade.attr("href", "https://twitter.com/intent/tweet?original_referer=" + (url) + "&text=" + (description) + "&url=" + (url) + "&via=artsy", true, true)) + " target=\"_blank\" class=\"share-to-twitter\"><i class=\"icon-twitter\"><span class=\"screen-reader-text\">Share on Twitter</span></i></a><a data-message=\"Share via email\" data-service=\"email\"" + (jade.attr("href", "mailto:?subject=" + (description) + "&body=Check out " + (description) + " on Artsy: " + (url) + "", true, true)) + " class=\"share-by-email\"><i class=\"icon-mail\"><span class=\"screen-reader-text\">Share via email</span></i></a>");
};
jade_mixins["author-date"] = jade_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div class=\"article-author-date\"><div" + (jade.cls(['article-author',article.get('contributing_authors') && article.get('contributing_authors').length > 0 ? 'has-contributing-author' : ''], [null,true])) + ">");
if ( article.related())
{
buf.push(jade.escape(null == (jade_interp = article.related().author.get('name')) ? "" : jade_interp));
}
buf.push("</div>");
if ( article.get('contributing_authors') && article.get('contributing_authors').length > 0)
{
buf.push("<div class=\"article-contributing-author\">" + (jade.escape(null == (jade_interp = "By " + article.byline()) ? "" : jade_interp)) + "</div>");
}
if ( article.get('news_source'))
{
buf.push("<div class=\"article-date-source\">");
jade_mixins["articleDate"](article.date('published_at'));
jade_mixins["newsSource"](article.get('news_source'));
buf.push("</div>");
}
else
{
jade_mixins["articleDate"](article.date('published_at'));
}
buf.push("</div>");
};
jade_mixins["articleDate"] = jade_interp = function(date){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div class=\"article-date\">" + (jade.escape(null == (jade_interp = date.format('MMM Do, YYYY h:mm a')) ? "" : jade_interp)) + "</div>");
};
jade_mixins["newsSource"] = jade_interp = function(source){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div class=\"article-news-source\">");
if ( source.url && source.title)
{
buf.push("<span>via </span><a" + (jade.attr("href", source.url, true, true)) + " target=\"_blank\">" + (jade.escape(null == (jade_interp = source.title) ? "" : jade_interp)) + "</a>");
}
buf.push("</div>");
};
jade_mixins["video"] = jade_interp = function(video){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div class=\"article-video-container\">");
if ( video.cover_image_url)
{
buf.push("<div" + (jade.attr("style", ("background-image: url(" + (resize(video.cover_image_url, { width: 1100 })) + ")"), true, true)) + " class=\"article-video-cover-image\"><button class=\"article-video-play-button\"><div class=\"article-video-play-button-caret\"></div></button></div>");
}
buf.push("<div class=\"article-video\">" + (null == (jade_interp = embed(video.url, { query: { title: 0, portrait: 0, badge: 0, byline: 0, showinfo: 0, rel: 0, controls: 2, modestbranding: 1, iv_load_policy: 3, color: "E5E5E5" } })) ? "" : jade_interp) + "</div>");
if ( video.caption)
{
buf.push("<figcaption>" + (null == (jade_interp = video.caption) ? "" : jade_interp) + "</figcaption>");
}
buf.push("</div>");
};
jade_mixins["imageSet"] = jade_interp = function(section){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div class=\"article-section-image-set__images\">");
// iterate section.images.slice(0,3)
;(function(){
  var $$obj = section.images.slice(0,3);
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var item = $$obj[i];

buf.push("<div" + (jade.attr("data-index", i, true, true)) + " class=\"article-section-image-set__image-container hoverable-image-link\">");
var image = resize( (item.image || item.url || ''), {height: 150} )
buf.push("<img" + (jade.attr("src", image, true, true)) + (jade.attr("alt", _s.stripTags(item.type === 'image' ? item.caption : item.title), true, true)) + " class=\"hoverable-image\"></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var item = $$obj[i];

buf.push("<div" + (jade.attr("data-index", i, true, true)) + " class=\"article-section-image-set__image-container hoverable-image-link\">");
var image = resize( (item.image || item.url || ''), {height: 150} )
buf.push("<img" + (jade.attr("src", image, true, true)) + (jade.attr("alt", _s.stripTags(item.type === 'image' ? item.caption : item.title), true, true)) + " class=\"hoverable-image\"></div>");
    }

  }
}).call(this);

buf.push("</div><div class=\"article-section-image-set__remaining\"><div" + (jade.attr("data-total", "" + (section.images.length) + "", true, true)) + (jade.cls(['article-section-image-set__icon',section.images.length > 9 ? 'is-double-digit' : ''], [null,true])) + "><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\"><defs><style>.cls-1{fill:#231f20;}</style></defs><path class=\"cls-1\" d=\"M6760.67,551.72h-32v-32h32v32Zm-30-2h28v-28h-28v28Z\" transform=\"translate(-6728.67 -507.72)\"/><polygon class=\"cls-1\" points=\"38 37 36 37 36 8 7 8 7 6 38 6 38 37\"/><polygon class=\"cls-1\" points=\"44 31 42 31 42 2 13 2 13 0 44 0 44 31\"/></svg></div><div class=\"article-section-image-set__text\">Enter Slideshow</div></div>");
};
jade_mixins["embed"] = jade_interp = function(section){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div class=\"article-embed-container\"><iframe" + (jade.attr("src", section.url, true, true)) + (jade.attr("height", section.height, true, true)) + (jade.attr("data-d-height", section.height, true, true)) + (jade.attr("data-m-height", section.mobile_height, true, true)) + " scrolling=\"no\" frameborder=\"0\"></iframe></div>");
};
jade_mixins["imageCollection"] = jade_interp = function(images){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<ul>");
// iterate images
;(function(){
  var $$obj = images;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var image = $$obj[i];

if ( image.type == 'artwork')
{
jade_mixins["artwork"](image);
}
else
{
jade_mixins["image"](image);
}
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var image = $$obj[i];

if ( image.type == 'artwork')
{
jade_mixins["artwork"](image);
}
else
{
jade_mixins["image"](image);
}
    }

  }
}).call(this);

buf.push("</ul>");
};
jade_mixins["image"] = jade_interp = function(image){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<li><figure><img" + (jade.attr("src", resize(image.url, { width: 1100 }), true, true)) + (jade.attr("alt", _s.stripTags(image.caption || ''), true, true)) + ">");
if ( image.caption)
{
buf.push("<figcaption>" + (null == (jade_interp = image.caption) ? "" : jade_interp) + "</figcaption>");
}
buf.push("</figure></li>");
};
jade_mixins["printArtistName"] = jade_interp = function(artist){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if ( artist.slug)
{
buf.push("<a" + (jade.attr("href", '/artist/' + artist.slug, true, true)) + ">" + (jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp)) + "</a>");
}
else if ( artist.name)
{
buf.push("= artist.name");
}
};
jade_mixins["artwork"] = jade_interp = function(artwork){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<li" + (jade.attr("data-id", artwork.id, true, true)) + "><figure class=\"artwork-item\"><div class=\"artwork-item-image-container\"><a" + (jade.attr("href", '/artwork/' + artwork.slug, true, true)) + " class=\"artwork-item-image-link\"><div class=\"artwork-item-image\"><img" + (jade.attr("src", artwork.image, true, true)) + (jade.attr("alt", artwork.title, true, true)) + "></div></a></div>");
jade_mixins["artwork_caption"](artwork);
buf.push("</figure></li>");
};
jade_mixins["artwork_caption"] = jade_interp = function(artwork){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<figcaption class=\"artwork-item-caption\"><p class=\"artwork-item-artist artwork-item-overflow\">");
if ( artwork.artists && artwork.artists.length > 0)
{
// iterate artwork.artists
;(function(){
  var $$obj = artwork.artists;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var artist = $$obj[i];

jade_mixins["printArtistName"](artist);
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var artist = $$obj[i];

jade_mixins["printArtistName"](artist);
    }

  }
}).call(this);

}
else if ( artwork.artist && artwork.artist.name)
{
jade_mixins["printArtistName"](artwork.artist);
}
buf.push("</p>");
if ( artwork.title)
{
buf.push("<p class=\"artwork-item-title artwork-item-overflow\">");
if ( artwork.slug)
{
buf.push("<a" + (jade.attr("href", '/artwork/' + artwork.slug, true, true)) + "><em>" + (jade.escape(null == (jade_interp = artwork.title) ? "" : jade_interp)) + "</em>");
if ( artwork.date)
{
buf.push(",&nbsp" + (jade.escape(null == (jade_interp = artwork.date) ? "" : jade_interp)));
}
buf.push("</a>");
}
else
{
buf.push("<em>" + (jade.escape(null == (jade_interp = artwork.title) ? "" : jade_interp)) + "</em>");
if ( artwork.date)
{
buf.push(",&nbsp" + (jade.escape(null == (jade_interp = artwork.date) ? "" : jade_interp)));
}
}
buf.push("</p>");
}
if ( artwork.partner && artwork.partner.name)
{
buf.push("<p class=\"artwork-item-partner artwork-item-overflow\">");
if ( artwork.partner.slug)
{
buf.push("<a" + (jade.attr("href", '/' + artwork.partner.slug, true, true)) + ">" + (jade.escape(null == (jade_interp = artwork.partner.name) ? "" : jade_interp)) + "</a>");
}
else
{
buf.push(jade.escape(null == (jade_interp = artwork.partner.name) ? "" : jade_interp));
}
buf.push("</p>");
}
buf.push("</figcaption>");
};
buf.push("<div" + (jade.attr("data-id", article.get('id'), true, true)) + " class=\"article-container\"><div class=\"article-content\"><div data-section-type=\"hero\" class=\"main-layout-container first\">");
if ( article.get('hero_section') && article.get('hero_section').type === 'video')
{
buf.push("<div class=\"article-large-format-video-container\">");
jade_mixins["video"](article.get('hero_section'));
buf.push("</div>");
}
if ( article.get('hero_section') && article.get('hero_section').type === 'image')
{
buf.push("<div class=\"article-large-format-image\">");
jade_mixins["image"](article.get('hero_section'));
buf.push("</div>");
}
if ( article.get('hero_section') && article.get('hero_section').type === 'image_collection')
{
buf.push("<div class=\"article-large-format-image\">");
jade_mixins["imageCollection"](article.get('hero_section').images);
buf.push("</div>");
}
buf.push("</div>");
if ( !hideShare)
{
buf.push("<div" + (jade.attr("data-id", article.get('id'), true, true)) + " class=\"article-share-fixed\">");
jade_mixins["share-fixed"]((article.get('share_description') || article.get('thumbnail_title')), article.get('thumbnail_image'), article.fullHref());
buf.push("</div>");
}
buf.push("<div class=\"article-header responsive-layout-container\"><h1 class=\"large-garamond-header\">" + (jade.escape(null == (jade_interp = article.get('title')) ? "" : jade_interp)) + "</h1>");
if ( article.strip('lead_paragraph'))
{
buf.push("<div class=\"article-lead-paragraph\">" + (null == (jade_interp = article.get('lead_paragraph')) ? "" : jade_interp) + "</div>");
}
jade_mixins["author-date"]();
buf.push("</div><div class=\"responsive-layout-container\">");
if ( article.get('sections').length && article.get('sections')[0].type == 'slideshow')
{
buf.push("<div class=\"article-carousel\">");
jade_mixins["carouselFigure"] = jade_interp = function(item){
var block = (this && this.block), attributes = (this && this.attributes) || {};
switch (item.type){
case 'image':
buf.push("<img" + (jade.attr("src", item.url, true, true)) + ">");
  break;
case 'video':
buf.push(null == (jade_interp = embed(item.url)) ? "" : jade_interp);
  break;
case 'artwork':
imageWidth = '500'
if ( slideshowArtworks)
{
artwork = slideshowArtworks.findWhere({ _id: item.id })
if ( artwork)
{
artworkSize = artworkSize || 'medium'
imageWidth = imageWidth || false
imageHeight = imageHeight || false
displayPurchase = displayPurchase || false
showBlurbs = showBlurbs || false
isAuction = isAuction || (set && set.get('type') === 'auction artworks') || false
hasInstitutionPartner = artwork.get('partner') && artwork.get('partner').type === 'Institution' && !artwork.get('forsale')
displayPrice != null ? displayPrice : displayPrice = true
saleArtwork = artwork.related().saleArtwork
hasAuctionPartner = (artwork.get('partner') && (artwork.get('partner').type === 'Auction' || artwork.get('partner').type === 'Auction House')) || artwork.get('is_biddable')
showContact = !isAuction && artwork.isContactable()
showBuyButton = displayPurchase && artwork.get('acquireable')
showBuyLink = artwork.get('acquireable') && artwork.get('ecommerce') && !showBuyButton
buf.push("<figure" + (jade.attr("data-artwork", artwork.get('id'), true, true)) + (jade.attr("data-id", artwork.get('_id'), true, true)) + " class=\"artwork-item\"><div class=\"artwork-item-image-container\"><a" + (jade.attr("href", artwork.href(), true, true)) + " class=\"artwork-item-image-link\">");
if ( imageWidth)
{
var defaultImage = artwork.defaultImage()
var maxDimension = maxDimension || imageWidth * 2
buf.push("<img" + (jade.attr("src", defaultImage.imageUrlForWidth(imageWidth), true, true)) + (jade.attr("nopin", artwork.noPinAttr(), true, true)) + (jade.attr("alt", artwork.toAltText(), true, true)) + (jade.attr("width", defaultImage.maxWidthForWidth(imageWidth, maxDimension), true, true)) + (jade.attr("height", defaultImage.maxHeightForWidth(imageWidth, maxDimension), true, true)) + " class=\"artwork-item-image\">");
}
else if ( imageHeight)
{
var defaultImage = artwork.defaultImage()
var maxDimension = maxDimension || imageHeight * 2
buf.push("<img" + (jade.attr("src", defaultImage.imageUrlForHeight(imageHeight), true, true)) + (jade.attr("nopin", artwork.noPinAttr(), true, true)) + (jade.attr("alt", artwork.toAltText(), true, true)) + (jade.attr("height", defaultImage.maxHeightForHeight(imageHeight, maxDimension), true, true)) + " class=\"artwork-item-image\">");
}
else
{
image = artwork.defaultImage()
imageSizes = (artworkSize instanceof Array ? artworkSize : [artworkSize]).concat(['tall', 'large', 'larger', 'medium', 'small'])
if ( !image.isCropped(artworkSize) && image.hasDimensions())
{
buf.push("<div" + (jade.attr("style", "padding-bottom: " + (image.factor() * 100) + "%", true, true)) + " class=\"artwork-item-image\"><img" + (jade.attr("src", image.bestImageUrl(imageSizes), true, true)) + (jade.attr("nopin", artwork.noPinAttr(), true, true)) + (jade.attr("alt", artwork.toAltText(), true, true)) + "></div>");
}
else
{
buf.push("<img" + (jade.attr("src", image.bestImageUrl(imageSizes), true, true)) + (jade.attr("nopin", artwork.noPinAttr(), true, true)) + (jade.attr("alt", artwork.toAltText(), true, true)) + " class=\"artwork-item-image\">");
}
}
if ( artwork.collection && artwork.collection.artworkCollection)
{
buf.push("<div" + (jade.attr("data-id", artwork.get('id'), true, true)) + (jade.attr("data-collection-id", artwork.collection.artworkCollection.id, true, true)) + " class=\"artwork-item-remove icon-remove-small\"></div>");
}
buf.push("<div class=\"overlay-container\"><div class=\"overlay-button-save\"></div></div></a></div><figcaption class=\"artwork-item-caption\">");
if ( artwork.related().artists.length)
{
buf.push("<p class=\"artwork-item-artist artwork-item-overflow\">");
// iterate artwork.related().artists.models
;(function(){
  var $$obj = artwork.related().artists.models;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var artist = $$obj[i];

if ( artist.get('public'))
{
buf.push("<a" + (jade.attr("href", artist.href(), true, true)) + " class=\"faux-underline-hover\">" + (jade.escape(null == (jade_interp = artist.displayName()) ? "" : jade_interp)) + "</a>");
}
else
{
buf.push(jade.escape(null == (jade_interp = artist.displayName()) ? "" : jade_interp));
}
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var artist = $$obj[i];

if ( artist.get('public'))
{
buf.push("<a" + (jade.attr("href", artist.href(), true, true)) + " class=\"faux-underline-hover\">" + (jade.escape(null == (jade_interp = artist.displayName()) ? "" : jade_interp)) + "</a>");
}
else
{
buf.push(jade.escape(null == (jade_interp = artist.displayName()) ? "" : jade_interp));
}
    }

  }
}).call(this);

buf.push("</p>");
}
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + " class=\"faux-underline-hover\">");
if ( isAuction && artwork.related().saleArtwork && artwork.related().saleArtwork.get('lot_label'))
{
buf.push("<div class=\"artwork-item-lot-number\">Lot " + (jade.escape((jade_interp = artwork.related().saleArtwork.get('lot_label')) == null ? '' : jade_interp)) + "</div>");
}
buf.push("<p class=\"artwork-item-title artwork-item-overflow\">" + (null == (jade_interp = artwork.titleAndYear()) ? "" : jade_interp) + "</p></a>");
if ( artwork.partnerName())
{
buf.push("<p class=\"artwork-item-partner artwork-item-overflow\">");
if ( artwork.partnerLink())
{
buf.push("<a" + (jade.attr("href", artwork.partnerLink(), true, true)) + " class=\"faux-underline-hover\">" + (jade.escape(null == (jade_interp = artwork.partnerName()) ? "" : jade_interp)) + "</a>");
}
else
{
buf.push(jade.escape(null == (jade_interp = artwork.partnerName()) ? "" : jade_interp));
}
buf.push("</p>");
}
if ( !hasInstitutionPartner && !hasAuctionPartner && !isAuction)
{
if ( artwork.saleMessage() && displayPrice)
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + " class=\"faux-underline-hover\"><p class=\"artwork-item-sale-price artwork-item-overflow\">" + (jade.escape(null == (jade_interp = artwork.saleMessage()) ? "" : jade_interp)) + "</p></a>");
}
else if ( artwork.availabilityMessage())
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + " class=\"faux-underline-hover\"><p class=\"artwork-item-availability\">" + (jade.escape(null == (jade_interp = artwork.availabilityMessage()) ? "" : jade_interp)) + "</p></a>");
}
}
if ( saleArtwork.id && isAuction)
{
if ( saleArtwork.estimate())
{
buf.push("<p class=\"artwork-item-estimate\">" + (jade.escape((jade_interp = saleArtwork.estimateLabel()) == null ? '' : jade_interp)) + ": " + (jade.escape((jade_interp = saleArtwork.estimate()) == null ? '' : jade_interp)) + "</p>");
}
}
var displayBidStatus = saleArtwork.id && isAuction
var displayBuyNowPrice = artwork.saleMessage() && displayPrice && isAuction
if ( displayBuyNowPrice || displayBidStatus)
{
buf.push("<div class=\"artwork-item-sale-metadata\">");
if ( artwork.get('sold'))
{
buf.push("<div class=\"artwork-item-buy-now-price\">" + (jade.escape(null == (jade_interp = artwork.saleMessage()) ? "" : jade_interp)) + "</div>");
}
else
{
if ( displayBidStatus)
{
var saleArtwork = artwork.related().saleArtwork
buf.push("<div class=\"artwork-item-auction-bid-status\">" + (jade.escape((jade_interp = saleArtwork.bidLabel()) == null ? '' : jade_interp)) + ": " + (jade.escape((jade_interp = saleArtwork.currentBid()) == null ? '' : jade_interp)) + "");
if ( saleArtwork.get('bidder_positions_count') >= 1)
{
buf.push("&nbsp;" + (jade.escape((jade_interp = saleArtwork.formatBidCount()) == null ? '' : jade_interp)) + "");
}
buf.push("</div>");
}
if ( displayBuyNowPrice)
{
buf.push("<div class=\"artwork-item-buy-now-price\">Buy now price: " + (jade.escape((jade_interp = artwork.saleMessage()) == null ? '' : jade_interp)) + "</div>");
}
}
buf.push("</div>");
}
if ( saleArtwork.id || showBlurbs)
{
var saleArtwork = artwork.related().saleArtwork
if ( artwork.has('blurb') && artwork.get('blurb'))
{
buf.push("<div class=\"artwork-item-blurb\">" + (null == (jade_interp = artwork.mdToHtml('blurb')) ? "" : jade_interp) + "</div>");
}
else
{
if ( saleArtwork && saleArtwork.get('user_notes'))
{
buf.push("<div class=\"artwork-item-blurb\">" + (null == (jade_interp = saleArtwork.mdToHtml('user_notes')) ? "" : jade_interp) + "</div>");
}
}
}
if ( saleArtwork.id || showBlurbs)
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + (jade.attr("data-id", artwork.get('_id'), true, true)) + " class=\"artwork-item-more-info avant-garde-button-black is-tiny\">More Info</a>");
}
if ( isAuction && !artwork.get('sold'))
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + (jade.attr("data-id", artwork.get('_id'), true, true)) + " class=\"artwork-item-bid avant-garde-button-black is-tiny\">Bid</a>");
if ( artwork.get('acquireable'))
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + (jade.attr("data-id", artwork.get('id'), true, true)) + " class=\"artwork-item-buy-now avant-garde-button-black is-tiny\">Buy now</a>");
}
}
if ( hasAuctionPartner && !isAuction)
{
buf.push("<div class=\"artwork-item-caption__bid-now\">");
if ( artwork.get('forsale') || artwork.get('is_for_sale'))
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + (jade.attr("data-id", artwork.get('id'), true, true)) + ">Bid now</a>");
}
else
{
buf.push("Auction closed");
}
buf.push("</div>");
}
if ( showBuyButton)
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + (jade.attr("data-id", artwork.get('id'), true, true)) + " class=\"artwork-item-buy avant-garde-button-black is-tiny\">Buy</a>");
}
else if ( showBuyLink)
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + (jade.attr("data-id", artwork.get('id'), true, true)) + " class=\"artwork-item-buy is-tiny\">Buy</a>");
}
else if ( showContact && !hasAuctionPartner)
{
buf.push("<a" + (jade.attr("href", artwork.href(), true, true)) + (jade.attr("data-artwork_id", artwork.get('_id'), true, true)) + " data-context_type=\"artwork feed item\" class=\"artwork-item-contact-seller js-artwork-item-contact-seller analytics-artwork-contact-seller\">Contact " + (jade.escape((jade_interp = artwork.contactLabel()) == null ? '' : jade_interp)) + "</a>");
}
buf.push("</figcaption></figure>");
}
}
  break;
}
};
buf.push("<div class=\"js-article-carousel\">");
items = article.get('sections')[0].items
buf.push("<div class=\"mgr-cells js-mgr-cells\">");
// iterate items
;(function(){
  var $$obj = items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

buf.push("<div class=\"mgr-cell js-mgr-cell\">");
jade_mixins["carouselFigure"](item);
buf.push("</div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var item = $$obj[$index];

buf.push("<div class=\"mgr-cell js-mgr-cell\">");
jade_mixins["carouselFigure"](item);
buf.push("</div>");
    }

  }
}).call(this);

buf.push("</div>");
length = items.length
if ( length > 1)
{
buf.push("<nav class=\"mgr-navigation js-mgr-navigation\">");
index = index || 0
buf.push("<a" + (jade.attr("disabled", disableStart, true, true)) + " class=\"mgr-arrow-left icon-chevron-left js-mgr-prev\"></a><div class=\"mgr-dots\">");
if (!( contain))
{
// iterate new Array(length)
;(function(){
  var $$obj = new Array(length);
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var x = $$obj[i];

buf.push("<div" + (jade.attr("data-index", i, true, true)) + (jade.cls(['mgr-dot','js-mgr-select',(index === i ? 'is-active' : undefined)], [null,null,true])) + ">•</div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var x = $$obj[i];

buf.push("<div" + (jade.attr("data-index", i, true, true)) + (jade.cls(['mgr-dot','js-mgr-select',(index === i ? 'is-active' : undefined)], [null,null,true])) + ">•</div>");
    }

  }
}).call(this);

}
buf.push("</div><a" + (jade.attr("disabled", disableEnd, true, true)) + " class=\"mgr-arrow-right icon-chevron-right js-mgr-next\"></a></nav>");
}
buf.push("</div></div>");
}
buf.push("</div>");
// iterate article.get('sections')
;(function(){
  var $$obj = article.get('sections');
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var section = $$obj[i];

buf.push("<div" + (jade.attr("data-layout", section.layout, true, true)) + (jade.attr("data-section-type", section.type, true, true)) + " class=\"article-section-container responsive-layout-container\">");
switch (section.type){
case 'text':
buf.push("<div class=\"article-section-text\">" + (null == (jade_interp = section.body) ? "" : jade_interp) + "</div>");
  break;
case 'video':
buf.push("<div" + (jade.cls(['article-section-video',"article-video-background-" + section.background_color], [null,true])) + ">");
jade_mixins["video"](section);
buf.push("</div>");
  break;
case 'embed':
buf.push("<div" + (jade.attr("data-layout", section.layout, true, true)) + " class=\"article-section-embed\">");
jade_mixins["embed"](section);
buf.push("</div>");
  break;
case 'image_set':
if ( section.images.length > 0)
{
buf.push("<div" + (jade.attr("data-index", i, true, true)) + " class=\"article-section-image-set\">");
jade_mixins["imageSet"](section);
buf.push("</div>");
}
  break;
case 'image_collection':
if ( section.images.length > 0)
{
buf.push("<div" + (jade.attr("data-index", i, true, true)) + (jade.attr("data-layout", section.layout, true, true)) + " class=\"article-section-image-collection\">");
jade_mixins["imageCollection"](section.images);
buf.push("</div>");
}
  break;
}
buf.push("</div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var section = $$obj[i];

buf.push("<div" + (jade.attr("data-layout", section.layout, true, true)) + (jade.attr("data-section-type", section.type, true, true)) + " class=\"article-section-container responsive-layout-container\">");
switch (section.type){
case 'text':
buf.push("<div class=\"article-section-text\">" + (null == (jade_interp = section.body) ? "" : jade_interp) + "</div>");
  break;
case 'video':
buf.push("<div" + (jade.cls(['article-section-video',"article-video-background-" + section.background_color], [null,true])) + ">");
jade_mixins["video"](section);
buf.push("</div>");
  break;
case 'embed':
buf.push("<div" + (jade.attr("data-layout", section.layout, true, true)) + " class=\"article-section-embed\">");
jade_mixins["embed"](section);
buf.push("</div>");
  break;
case 'image_set':
if ( section.images.length > 0)
{
buf.push("<div" + (jade.attr("data-index", i, true, true)) + " class=\"article-section-image-set\">");
jade_mixins["imageSet"](section);
buf.push("</div>");
}
  break;
case 'image_collection':
if ( section.images.length > 0)
{
buf.push("<div" + (jade.attr("data-index", i, true, true)) + (jade.attr("data-layout", section.layout, true, true)) + " class=\"article-section-image-collection\">");
jade_mixins["imageCollection"](section.images);
buf.push("</div>");
}
  break;
}
buf.push("</div>");
    }

  }
}).call(this);

if ( !hideShare)
{
buf.push("<div class=\"responsive-layout-container\"><div" + (jade.attr("data-id", article.get('id'), true, true)) + " class=\"article-social\"><h2 class=\"article-social__header\">Share article</h2>");
jade_mixins["share"]((article.get('share_description') || article.get('thumbnail_title')), article.get('thumbnail_image'), (sd.APP_URL + '/article/' + article.get('slug')));
buf.push("</div></div>");
}
buf.push("</div></div>");}.call(this,"Array" in locals_for_with?locals_for_with.Array:typeof Array!=="undefined"?Array:undefined,"_s" in locals_for_with?locals_for_with._s:typeof _s!=="undefined"?_s:undefined,"article" in locals_for_with?locals_for_with.article:typeof article!=="undefined"?article:undefined,"artwork" in locals_for_with?locals_for_with.artwork:typeof artwork!=="undefined"?artwork:undefined,"artworkSize" in locals_for_with?locals_for_with.artworkSize:typeof artworkSize!=="undefined"?artworkSize:undefined,"contain" in locals_for_with?locals_for_with.contain:typeof contain!=="undefined"?contain:undefined,"disableEnd" in locals_for_with?locals_for_with.disableEnd:typeof disableEnd!=="undefined"?disableEnd:undefined,"disableStart" in locals_for_with?locals_for_with.disableStart:typeof disableStart!=="undefined"?disableStart:undefined,"displayPrice" in locals_for_with?locals_for_with.displayPrice:typeof displayPrice!=="undefined"?displayPrice:undefined,"displayPurchase" in locals_for_with?locals_for_with.displayPurchase:typeof displayPurchase!=="undefined"?displayPurchase:undefined,"embed" in locals_for_with?locals_for_with.embed:typeof embed!=="undefined"?embed:undefined,"encodeURIComponent" in locals_for_with?locals_for_with.encodeURIComponent:typeof encodeURIComponent!=="undefined"?encodeURIComponent:undefined,"hasAuctionPartner" in locals_for_with?locals_for_with.hasAuctionPartner:typeof hasAuctionPartner!=="undefined"?hasAuctionPartner:undefined,"hasInstitutionPartner" in locals_for_with?locals_for_with.hasInstitutionPartner:typeof hasInstitutionPartner!=="undefined"?hasInstitutionPartner:undefined,"hideShare" in locals_for_with?locals_for_with.hideShare:typeof hideShare!=="undefined"?hideShare:undefined,"image" in locals_for_with?locals_for_with.image:typeof image!=="undefined"?image:undefined,"imageHeight" in locals_for_with?locals_for_with.imageHeight:typeof imageHeight!=="undefined"?imageHeight:undefined,"imageSizes" in locals_for_with?locals_for_with.imageSizes:typeof imageSizes!=="undefined"?imageSizes:undefined,"imageWidth" in locals_for_with?locals_for_with.imageWidth:typeof imageWidth!=="undefined"?imageWidth:undefined,"index" in locals_for_with?locals_for_with.index:typeof index!=="undefined"?index:undefined,"isAuction" in locals_for_with?locals_for_with.isAuction:typeof isAuction!=="undefined"?isAuction:undefined,"items" in locals_for_with?locals_for_with.items:typeof items!=="undefined"?items:undefined,"length" in locals_for_with?locals_for_with.length:typeof length!=="undefined"?length:undefined,"resize" in locals_for_with?locals_for_with.resize:typeof resize!=="undefined"?resize:undefined,"sd" in locals_for_with?locals_for_with.sd:typeof sd!=="undefined"?sd:undefined,"set" in locals_for_with?locals_for_with.set:typeof set!=="undefined"?set:undefined,"showBlurbs" in locals_for_with?locals_for_with.showBlurbs:typeof showBlurbs!=="undefined"?showBlurbs:undefined,"showBuyButton" in locals_for_with?locals_for_with.showBuyButton:typeof showBuyButton!=="undefined"?showBuyButton:undefined,"showBuyLink" in locals_for_with?locals_for_with.showBuyLink:typeof showBuyLink!=="undefined"?showBuyLink:undefined,"showContact" in locals_for_with?locals_for_with.showContact:typeof showContact!=="undefined"?showContact:undefined,"slideshowArtworks" in locals_for_with?locals_for_with.slideshowArtworks:typeof slideshowArtworks!=="undefined"?slideshowArtworks:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;